import React, { useState } from "react";

const OrderEditStatusChanger = ({
  orderId,
  coracaomedusatoken,
  orderStatus,
  customerPhone,
}) => {
  const [newStatus, setNewStatus] = useState("");

  const statusOptions = ["Dispatched", "Out for Delivery", "Delivered"];

  const sendWhatsAppNotification = async (phone) => {
    try {
      const payload = {
        user_id: 467,
        template_id: 265,
        campaign_type: 1,
        phone_number: `+91${phone}`,
        whatsapp_number_id: "913191195203935",
        whatsapp_number: "+916390640659",
        is_shorten_url: true,
        contact_temp_var_map: [{ "{{1}}": "coracao1232#" }],
        media_files: [""],
        use_dynamic_media: true,
        use_same_media_for_all: false,
        use_different_media_for_all: true,
        media_file: "",
        copy_code_values: "",
      };

      const response = await fetch(
        "https://queue.rcs.smscloud.in/api/v1/whatsapp/send-message",
        {
          method: "POST",
          headers: {
            apiKey: "f3c7c1e165721847fcb905b97",
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
          redirect: "follow",
        }
      );

      console.log("Raw response:", response);

      const result = await response.json().catch(() => null);
      console.log("WhatsApp Response JSON:", result);

      if (!response.ok) {
        console.error("WhatsApp API error:", result || response.statusText);
      }
    } catch (error) {
      console.error("WhatsApp API Error:", error.message);
    }
  };

  const handleChangeStatus = async (event) => {
    event.preventDefault();
    try {
      const orderEditData = {
        // order_id: orderId,
        status: newStatus,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_Coracaodovale_URL}admin/orders/${orderId}/status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${coracaomedusatoken}`,
          },
          body: JSON.stringify(orderEditData),
        }
      );

      // if (response.ok) {
      //   console.log("Order status updated successfully");

      //   if (newStatus === "Delivered" && customerPhone) {
      //     await sendWhatsAppNotification(customerPhone);
      //   }
      // } else {
      //   console.error("Failed to change order status");
      // }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="d-flex justify-content-start">
      <select
        className="form-control"
        style={{ width: "150px", fontSize: "13px", height: "42px" }}
        value={newStatus}
        onChange={(e) => setNewStatus(e.target.value)}
      >
        <option value="">Select Status</option>
        {statusOptions
          .filter((status) => orderStatus !== status)
          .map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
      </select>

      <button
        type="button"
        onClick={handleChangeStatus}
        className="text-wrap btn btn-warning bold ml-2"
      >
        <small style={{ fontSize: "12px" }}>Submit</small>
      </button>
    </div>
  );
};

export default OrderEditStatusChanger;
